import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { CreateOrUpdateRewardRequest, RewardResponse } from "../../rewards/rewardsApi";
import { createReward } from "../../rewards/rewardsApi";

export const useCreateReward = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const createRewardMutation = useMutation<RewardResponse, unknown, CreateOrUpdateRewardRequest>({
    mutationFn: (v) => createReward(v),
    onSuccess: async (data) => {
      enqueueSnackbar(`Nagroda ${data.name} została utworzona`, { variant: "success" });
      await queryClient.invalidateQueries({ queryKey: ["rewards"] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się stworzyć nagrody. Powód: ${(error as Error).message}`, { variant: "error" });
    },
  });

  return { createReward: (request: CreateOrUpdateRewardRequest) => createRewardMutation.mutateAsync(request) };
};
